import { render, staticRenderFns } from "./Congestion.vue?vue&type=template&id=718f418c&scoped=true&"
import script from "./Congestion.vue?vue&type=script&lang=js&"
export * from "./Congestion.vue?vue&type=script&lang=js&"
import style0 from "./Congestion.vue?vue&type=style&index=0&id=718f418c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718f418c",
  null
  
)

export default component.exports